import React from 'react'
import { Button, Modal, ModalBody, CardBody, Media, Col, Form, Input, FormFeedback, Row, Label } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalUpdateMethod = (props) => {

    const { modalPreviewUpdate, toggleModalUpdate, user_method, user_password_method, id_pay_method_method, handleInputChangeMethod, listPayMethod, validatePassword, aunthentication, loadingUpdateMethod } = props;


    return (
        <Dialog
            header={"Autorización de método de pago"}
            visible={modalPreviewUpdate}
            onHide={toggleModalUpdate}
            closable={true}
            modal
            style={{ width: "650px" }}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            className="pt-0 custom-dialog-img"

            footer={
                <div className="d-flex justify-content-end gap-2">

                    <Button
                        disabled={loadingUpdateMethod}
                        color="secondary"
                        type="button"
                        onClick={validatePassword}
                    >
                        Autorizar
                    </Button>
                    <Button
                        disabled={loadingUpdateMethod}
                        color="danger"
                        type="button"
                        onClick={toggleModalUpdate}
                    >
                        Cancelar
                    </Button>

                </div>
            }
        >

            <Form className="theme-form" role="form">

                <Row className="align-items-stretch">

                    <Col md="4" className="d-flex justify-content-center align-items-center border-end">

                        <div className="side-lock-wrapper-2">
                            <img
                                src={require("../../assets/images/blog/password.svg")}
                                alt="user"
                                className="side-lock-icon"
                            />
                        </div>

                    </Col>

                    <Col md="8">

                        <Row className="g-3 mb-3">

                            {/* Usuario */}
                            <Col md="12">
                                <Label className="form-label-sm">Usuario</Label>
                                <Input
                                    type="text"
                                    name="user_method"
                                    value={user_method}
                                    autoComplete="off"
                                    onChange={handleInputChangeMethod}
                                    className={`form-control form-control-sm custom-input ${aunthentication ? 'border-danger' : 'border-primary'
                                        }`}
                                />
                                <FormFeedback>Escribe el usuario</FormFeedback>
                            </Col>

                            <Col md="12">
                                <Label className="form-label-sm">Contraseña</Label>
                                <Input
                                    type="password"
                                    name="user_password_method"
                                    value={user_password_method}
                                    autoComplete="off"
                                    onChange={handleInputChangeMethod}
                                    className={`form-control form-control-sm custom-input ${aunthentication ? 'border-danger' : 'border-primary'
                                        }`}
                                />
                                <FormFeedback>Escribe la contraseña</FormFeedback>
                            </Col>

                            <Col md="12">
                                <Label className="form-label-sm">Método de Pago</Label>
                                <Input
                                    type="select"
                                    name="id_pay_method_method"
                                    value={id_pay_method_method}
                                    onChange={handleInputChangeMethod}
                                    className="form-control form-control-sm custom-input border-primary"
                                >
                                    <option value={0}>Selecciona una opción</option>
                                    {
                                        listPayMethod.map(_pMethod => (
                                            <option
                                                value={_pMethod.id_pay_method}
                                                key={`method-${_pMethod.id_pay_method}`}
                                            >
                                                {_pMethod.abbreviation} - {_pMethod.name}
                                            </option>
                                        ))
                                    }
                                </Input>
                            </Col>

                        </Row>

                    </Col>

                </Row>

            </Form>

        </Dialog>

    )
}
